import styled from 'styled-components';
import {
  PrimaryButtonComponent,
  DataValue,
  UnderlineLink as CommonLink
} from '../../../../../../CommonComponents/commonStyles';
import { TableLabel } from '../../styles';

export const PrimaryButton = styled(PrimaryButtonComponent)`
  width: 300px;
`;

export const Text = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.textColor};
`;

export const BoldText = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
`;

export const UnderlineLink = styled(CommonLink)`
  font-family: ${props => props.theme.fontFamily.HelveticaNeue};
  font-size:  ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.primary};
  text-decoration: underline !important;
  &:hover {
    color: ${props => props.theme.fontColors.primary};
  }
`;
export const NoResult = styled.div`
  text-align: center;
`;

export const IconPadding = styled.div`
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  margin-right: ${props => (props.primary ? '50px' : '')};
  @media (max-width: 990px) {
    margin-left: 0px;
    margin-right: 20px;
  }
`;

export const DataExportPrint = styled(DataValue)`
  margin: 0px 5px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
  display: block;
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const WorkBookPrintWrap = styled.div`
  position: relative;
  @media only screen and (max-width: 768px) {
    margin-bottom: 1rem;
  }
  .wrapper {
    position: absolute;
    bottom: -3rem;
    z-index: 1;
    @media only screen and (max-width: 768px) {
      position: static;
    }
  }
`;

export const SearchTableLabel = styled(TableLabel).attrs(()=>({
  className: "scrollUp"
  }))`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.headingColor} !important;
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;
